import { LeadsType } from "app/pages/sales-intelligence/sub-modules/company-search/types/common";
import createCRMLeadsSelectionDropdown from "app/pages/sales-intelligence/sub-modules/management/models/websites-crm-export/factory";

const crmExportSelectionDropdown = createCRMLeadsSelectionDropdown(LeadsType.Websites);

export default crmExportSelectionDropdown;
